import { Navigate, useLocation } from "react-router-dom";

type StripPrefixRedirectProps = {
  prefix: string;
  fallbackTo: string;
};

const StripPrefixRedirect: React.FC<StripPrefixRedirectProps> = ({ prefix, fallbackTo }) => {
  const location = useLocation();
  const normalizedPrefix = prefix.endsWith("/") ? prefix.slice(0, -1) : prefix;
  const path = location.pathname;

  let nextPath = path;
  if (path === normalizedPrefix) {
    nextPath = fallbackTo;
  } else if (path.startsWith(`${normalizedPrefix}/`)) {
    let remainder = path;
    // Collapse repeated legacy prefixes in one redirect, e.g. /provider/provider/dashboard.
    while (remainder === normalizedPrefix || remainder.startsWith(`${normalizedPrefix}/`)) {
      remainder = remainder.slice(normalizedPrefix.length) || "/";
    }
    nextPath = remainder === "/" ? fallbackTo : remainder;
  }

  if (!nextPath.startsWith("/")) {
    nextPath = `/${nextPath}`;
  }

  return <Navigate to={`${nextPath}${location.search}${location.hash}`} replace />;
};

export default StripPrefixRedirect;
